import data from './data'
import components from './components'
import mounted from './mounted'
import methods from './methods'
import computed from './computed'

export default {
  data,
  components,
  mounted,
  methods,
  computed,
  resourcePath: '/v1/dweller/files'
}



// WEBPACK FOOTER //
// ./src/app/tenant/files/resources/index.js